export default __webpack_public_path__ + "static/media/torso-mid-right-side.328cb4ad.png";